import { ref, reactive, onMounted, onBeforeUnmount } from 'vue';
import { useRouter, onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router';

import { useFormsChanged } from '@/components/common/useFormsChanged';

// использовать с этим компонентом
// import RouteLeaveModal from '@/components/common/RouteLeaveModal';
export function useRouteLeaveModal() {
	const modalVisible = ref(false);
	const formChangedStatuses = reactive({});

	const nextRoute = ref(null);
	const { formsChanged } = useFormsChanged(formChangedStatuses);

	const router = useRouter();
	const modalOk = () => {
		modalVisible.value = false;
		for (let key of Object.keys(formChangedStatuses)) {
			formChangedStatuses[key] = false;
		}
		router.push(nextRoute.value);
	};
	const modalCancel = () => modalVisible.value = false;

	// on tab close
	const beforeUnload = event => {
		if (formsChanged.value) {
			event.preventDefault();
		}
	};
	onMounted(() => {
		window.scrollTo(0, 0);
		window.addEventListener('beforeunload', beforeUnload);
	});
	onBeforeUnmount(() => window.removeEventListener('beforeunload', beforeUnload));

	// on navigation event
	const checkFormsChanged = to => {
		if (formsChanged.value) {
			modalVisible.value = true;
			nextRoute.value = to;
			return false;
		}
		return true;
	}
	onBeforeRouteUpdate(checkFormsChanged);
	onBeforeRouteLeave(checkFormsChanged);

	return {
		formChangedStatuses,
		modalVisible,
		formsChanged,
		modalOk,
		modalCancel,
	};
}
